<template>
  <div class="modal-mask">
    <section class="modal reduced">
      <div class="content">
        <h1 v-if="parMethod=='add_groupOfDiscount'">{{$t('createCampaign.addGroupOfDiscount')}}</h1>
        <h1 v-if="parMethod=='modify_groupOfDiscount'">{{$t('groupOfDiscountsSection.modifyGroupOfDiscountsAction')}}</h1>
        <hr>
        <div>
          <p class="accentuate">{{$t('groupOfDiscounts.groupOfDiscountsTitle')}}</p>
          <div class="spacer-10"></div>
          <label>{{$t('groupOfDiscounts.groupOfDiscountsName')}}</label>
          <div class="demiRow">
            <input type="text" v-model="currentGroupOfDiscount['name']">
          </div>
          <label>{{$t('createCampaign.totalUse')}}</label>
          <span
            class="errorSentence"
            v-if="textFieldRequiredMaxNumberOfUses && isSubmit"
          >* {{$t('error.textFieldRequired')}}</span>
          <div class="row">
            <div class="dataEndInput">
              <p>{{$t('createCampaign.number')}}</p>
              <input
                type="number"
                v-bind:class="{ 'error' : textFieldRequiredMaxNumberOfUses && isSubmit,'mInput' :true}"
                v-model="currentGroupOfDiscount['max-number-of-uses']"
              >
            </div>
            <p class="tips">{{$t('createCampaign.totalUseTips')}}</p>
          </div>
          <div class="row">
          <button @click="confirmNewGroupOfDiscount()">{{$t('button.validate')}}</button>
          <a @click="$emit('close')">{{$t('button.cancel')}}</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


 <script>
import getProducts from "@/mixins/getProducts";

export default {
  props: ["parGroupOfDiscount", "parMethod"],
  mixins: [getProducts],
  data() {
    return {
      isSubmit: false,
      currentGroupOfDiscount: {
        id: 0,
        "campaign-id": 0,
        name: "",
        "number-of-used-coupons": 0,
        "max-number-of-uses": 0,
        "max-number-of-uses-per-client": 1,
        "global-code": "",
        archived: false,
        discountsAssociated: []
      }
    };
  },
  computed: {
textFieldRequiredMaxNumberOfUses: function() {
      return !this.currentGroupOfDiscount["max-number-of-uses"];
    },
    textFieldRequiredGroupOfDiscountName: function() {
      return !this.currentGroupOfDiscount["name"];
    },
  },
  mounted() {
    if (this.parMethod == "modify_groupOfDiscount") {
        this.currentGroupOfDiscount = this.parGroupOfDiscount;
    }
  },
  methods: {
  confirmNewGroupOfDiscount() {
      this.isSubmitted = true;
      if (!this.textFieldRequiredMaxNumberOfUses
      &&
      !this.textFieldRequiredGroupOfDiscountName
      ) {
        var returnedData = {};
        returnedData.groupOfDiscount = this.currentGroupOfDiscount;
        if (this.parMethod == "add_groupOfDiscount")
          returnedData.method = "add_groupOfDiscount";
        if (this.parMethod == "modify_groupOfDiscount")
          returnedData.method = "modify_groupOfDiscount";
        this.$emit("operationondiscountdone", returnedData);
        this.$emit("close");
      }
    }

  }
};
</script>
              